export default "__VITE_ASSET__C2i8_MgQ__"